<template>
  <v-container fluid >
    <!-- Navegación izquierda -->
    <v-navigation-drawer
      v-model="sidenav"
      app
      fixed
      width="235"
    >
      <v-list nav dense>
        <v-list-item class="d-flex justify-center mt-14">
          <v-avatar size="128" class="" style="background-color: red">
            <v-img
              v-if="
                user.profilePicture != '' &&
                user.profilePicture != 'NOT_ASSIGNED'
              "
              :src="user.profilePicture"
              max-width="150"
            ></v-img>
            <v-img
              v-else
              contain
              class="pa-9"
              src="@/assets/images/weChamber/logo-WC-microsite-2.svg"
            ></v-img>
          </v-avatar>
        </v-list-item>
      </v-list>
      <v-list nav rounded dense>
        <v-list-item-group>
          <v-list-item
            :to="{ name: entityType=='Event'?'mis-eventos': entityType == 'Chapter' ? 'chapters' : 'myMembers' }"
            class="px-6 px-md-2"
            active-class="white--text wDarkerBlue"
          >
            <v-list-item-icon>
              <v-icon>fas fa-chevron-left</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Volver al inicio</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="({ name, icon, title }) in navigationsComputed"
            :key="name"
            :to="{ name, params: { eventId: $route.params.eventId }}"
            :disabled="title=='Panel Local'||title=='Mis Eventos'"
            class="px-6 px-md-2"
            active-class="white--text wDarkerBlue"
          >
            <v-list-item-icon>
              <v-badge color="red" dot :value="badgeComputed(title)">
                <v-icon>{{icon}}</v-icon>
              </v-badge>
            </v-list-item-icon>
            <v-list-item-title>{{title}}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <!-- / Navegación izquierda -->
    <!-- Menú derecho -->
    <v-row>
      <v-col
      cols="12"
      class="d-flex justify-end my-4"
    >
      <v-btn
        v-if="$vuetify.breakpoint.smAndDown"
        class="mx-2"
        color="primary"
        icon
        large
        @click="sidenav = true"
      >
        <v-icon>
          mdi-menu
        </v-icon>
      </v-btn>
      <account-menu @logOut="closeLogOutDialog"></account-menu>
    </v-col>
    </v-row>
    <PersonalizedDialog
    :dialog="logOutDialog"
    @save="_logout"
    @discard="logOutDialog=false">
      <template v-slot:alertContent>
        <p class="title text-center">
              ¿Está seguro que desea cerrar sesión?
                </p>
      </template>
    </PersonalizedDialog>
    <!-- / Menú derecho -->
  </v-container>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import OrganizerBalance from "./DashboardNavbar/OrganizerBalance";
import AccountMenu from './DashboardNavbar/AccountMenu.vue';
import PersonalizedDialog from '../shared/PersonalizedDialog.vue';
export default {
  props: ['entityType' ,'navigations'],
  components: {
    OrganizerBalance,
    PersonalizedDialog,
    AccountMenu
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState('event', ['eventSelected']),
    navigationsComputed(){
      if(this.entityType=='Event' && this.eventSelected && this.eventSelected.invitationalEvent){
        return this.navigations.filter(navigation=>navigation.title!='Accesos y ventas');
      }else{
        return this.navigations;
      }
    },
  },
  data() {
    return {
      sidenav: false,
      logOutDialog: false
    }
  },
  methods: {
    ...mapActions('user', ['logout']),
    async _logout(){
      await this.logout();
    },
    closeLogOutDialog(){
      this.logOutDialog=true
    },
    badgeComputed(title = null) {
      if (title != 'Accesos y ventas') return false
      const { totalTickets = null } = this.eventSelected || {};
      if (!totalTickets) return true;

      return totalTickets <= 0
    }
  },
  mounted() {
    if (this.$vuetify.breakpoint.mdAndUp) {
      this.sidenav = true;
    }
  }
}
</script>
<style scoped>
.rounded-container {
  border-radius: 6rem !important;
}
</style>